export default __webpack_public_path__ + "static/media/cpt2.06004833.png";